import * as React from "react";
import RegistracePage from "../../../components/customOrgs/senzacni/RegistracePage";

export default function Registrace() {
    return <RegistracePage />;
}
